module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ep"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("On the field of battle it is a disgrace to the chief to be surpassed in valour by his companions, a disgrace to the companions not to come up to the valour of their chief. As for leaving a battle alive after your chief has fallen, that means lifelong infamy and shame. To defend and protect him, to put down one’s acts of heroism to his credit – that is really what they mean by allegiance. The chiefs fight for victory, the companions for their chief.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("Tacitus, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Germania")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-542f3a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0